import { config } from '../domain/config'
import { GoogleRepository } from './googleRepository'
import type { AppRepository } from './repositoryTypes'

export const repository: AppRepository = config.mode === 'supabase'
  ? new (await import('./supabaseRepository')).SupabaseRepository()
  : config.mode === 'google'
  ? new GoogleRepository()
  : (await import('./mockRepository')).mockRepository
